import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { JWTProvider } from 'contexts/JWTContext';
import { PageSettingsProvider } from 'contexts/PageSettingsContext';
import { PlaybackCoordinatorProvider } from 'contexts/PlaybackCoordinatorContext';
import {KeyMomentActiveFiltersProvider} from "./contexts/application/KeyMomentActiveFilters";
import {ClipActiveFiltersProvider} from "./contexts/application/ClipActiveFilters";
import {SelectedContentProvider} from "./contexts/SelectedContentContext";
import {SSEProv} from "./contexts/application/SSEProvider";
import {SelectedCardProvider} from "./contexts/SelectedCardContext.tsx";

import {EditorProvider} from "@/contexts/editor/EditStateContext.tsx";
import {EditorSelectedElementsProvider} from "@/contexts/editor/EditorSelectedElements";
import {MaterializationSettingsProvider} from "@/contexts/MaterializationSettingsContext";
import {NotificationProvider} from "@/contexts/NotificationProvider";
import {ContentSpecificProvider} from "@/contexts/ContentSpecificParamsContext";
import {EditorKeyMomentsProvider} from "@/contexts/EditorKeyMomentsCuts";
import {EditorialAssetsProvider} from "@/contexts/EditorialAssetsContext";
import {SocialPublicationProvider} from "@/contexts/SocialPublicationContext";
import {OutputSSEProvider} from "./contexts/application/OutputSSEProvider";
import {RightDrawerProvider} from "@/contexts/application/RightDrawerContext";
import {ChatProvider} from "@/contexts/ChatContext";
import {DimensionCardProv} from "@/contexts/application/DimensionCardsProvider";
import AxiosInterceptor from "@/contexts/AxiosInterceptor";
import {TourProvider} from "@/contexts/TourContext";
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
import { DirectJWTProvider } from '@/contexts/DirectJWTContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { SupabseProvider as AuthProvider } from 'contexts/SupabaseContext';

import { TARGET_APP_BUILD, TARGET_APP_BUILD_VALUE } from "/src/constants/globalConstants.ts";
import {SuggestedCutsProvider} from "@/contexts/SuggestedCutsContext";
import {FullscreenProvider} from "@/contexts/FullscreenContext";
import {TimelineEventProvider} from "@/contexts/GameEventsContext";

// Crea il componente dinamicamente prima del render
const AuthProvider = TARGET_APP_BUILD === TARGET_APP_BUILD_VALUE.BACKUP ? DirectJWTProvider : JWTProvider;

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <AuthProvider>
                  <AxiosInterceptor>
                      <RightDrawerProvider>
                          <PageSettingsProvider>
                              <PlaybackCoordinatorProvider>
                                  <EditorSelectedElementsProvider>
                                      <SelectedContentProvider>
                                          <EditorProvider>
                                              <KeyMomentActiveFiltersProvider>
                                                  <SelectedCardProvider>
                                                      <ClipActiveFiltersProvider>
                                                          <NotificationProvider>
                                                              <Notistack
                                                                  autoHideDuration={2500}
                                                              >
                                                                  <SSEProv>
                                                                      <OutputSSEProvider>
                                                                          <DimensionCardProv>
                                                                              <MaterializationSettingsProvider>
                                                                                  <ContentSpecificProvider>
                                                                                      <EditorialAssetsProvider>
                                                                                          <EditorKeyMomentsProvider>
                                                                                              <SocialPublicationProvider>
                                                                                                  <TourProvider>
                                                                                                      <FullscreenProvider>
                                                                                                        <ChatProvider>
                                                                                                      <SuggestedCutsProvider>
                                                                                                          <TimelineEventProvider>
                                                                                                              <RouterProvider router={router} />
                                                                                                          </TimelineEventProvider>
                                                                                                      </SuggestedCutsProvider>
                                                                                                  </ChatProvider>
                                                                                                      </FullscreenProvider>
                                                                                                  </TourProvider>
                                                                                              </SocialPublicationProvider>
                                                                                          </EditorKeyMomentsProvider>
                                                                                      </EditorialAssetsProvider>
                                                                                  </ContentSpecificProvider>
                                                                              </MaterializationSettingsProvider>
                                                                          </DimensionCardProv>
                                                                      </OutputSSEProvider>
                                                                  </SSEProv>
                                                                  <Snackbar />
                                                              </Notistack>
                                                          </NotificationProvider>
                                                      </ClipActiveFiltersProvider>
                                                  </SelectedCardProvider>
                                              </KeyMomentActiveFiltersProvider>
                                          </EditorProvider>
                                      </SelectedContentProvider>
                                  </EditorSelectedElementsProvider>
                              </PlaybackCoordinatorProvider>
                          </PageSettingsProvider>
                      </RightDrawerProvider>
                  </AxiosInterceptor>
              </AuthProvider>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </>
  );
}
